/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aroma_Sampling_CodeInputs */

const vi_aroma_sampling_code = /** @type {(inputs: Aroma_Sampling_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã`)
};

/**

* @param {Aroma_Sampling_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aroma_sampling_code = /** @type {((inputs?: Aroma_Sampling_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aroma_Sampling_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aroma_sampling_code(inputs)
});